"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("../Link"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

class SupportLinks extends _react.default.Component {
  buildLinks() {
    return this.props.links.map(function (link, i) {
      if (!link.href) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: i
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: '#999',
            fontSize: '14px',
            textDecoration: 'none',
            letterSpacing: '1.2px',
            transition: 'all 0.2s ease-in-out'
          }
        }, link.text), /*#__PURE__*/_react.default.createElement("span", {
          style: {
            color: '#999',
            fontSize: '15px',
            padding: '0 5px'
          }
        }));
      }
      return /*#__PURE__*/_react.default.createElement("span", {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: link.href,
        style: {
          color: '#999',
          fontSize: '14px',
          textDecoration: 'none',
          letterSpacing: '1.2px',
          transition: 'all 0.2s ease-in-out',
          display: 'block',
          paddingLeft: '15px'
        },
        hoverStyles: {
          color: '#00a9f2'
        }
      }, link.text), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: '#999',
          fontSize: '15px',
          padding: '10px 5px',
          display: 'block'
        }
      }));
    }.bind(this));
  }
  renderButton() {
    if (!this.props.isMobile || typeof navigator === 'undefined') {
      return false;
    }
    let href = '';
    if (typeof navigator !== 'undefined' && (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i))) {
      href = this.props.mobileAppText.itunes && encodeURI(this.props.mobileAppText.itunes) || 'itms://itunes.apple.com/us/app/concur-travel-receipts-expense/id335023774?mt=8/';
    } else if (typeof navigator !== 'undefined' && navigator.userAgent.match(/Android/i)) {
      href = this.props.mobileAppText.android && encodeURI(this.props.mobileAppText.android) || 'https://play.google.com/store/apps/details?id=com.concur.breeze';
    }
    if (!href) {
      return false;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        margin: '48px 0'
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "visible-xs mobile-support-link",
      href: href,
      style: {
        margin: '30px 15px',
        clear: 'both',
        color: '#f0ab00',
        borderColor: '#f0ab00'
      }
    }, this.props.mobileAppText.text));
  }
  render() {
    const styles = {
      clear: 'both',
      backgroundColor: '#000',
      width: 'calc(100% + 30px)',
      margin: '20px 0 0 -15px'
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-12 text-left support-links hidden-lg",
      style: this.props.isMobile ? styles : {}
    }, this.renderButton(), this.buildLinks());
  }
}
exports.default = SupportLinks;
SupportLinks.propTypes = {
  links: _propTypes.default.array,
  isMobile: _propTypes.default.bool,
  mobileAppText: _propTypes.default.object
};
SupportLinks.defaultProps = {
  links: [],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};